import React from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import useI18n from '@/hooks/useI18n'

// Methods
import { getCompanyBrandName } from '@/components/pages/Terms/methods/company'

// Styles
import styles from './style.module.scss'

// Variable
const cx = classnames.bind(styles)

const LegalDisclaimer = () => {
  const { t } = useTranslation()
  const { isOverseaUser } = useI18n()

  return (
    <div className={cx('legal-disclaimer__container')}>
      <div className={cx('legal-disclaimer')}>
        <div className={cx('legal-disclaimer__title')}>{t('Legal_Disclaimer_Title', { brandName: getCompanyBrandName(isOverseaUser) })}</div>

        <div className={cx('legal-disclaimer__section')}>
          <div className={cx('legal-disclaimer__section-title')}>{t('Legal_Disclaimer_Title_1')}</div>
          <div className={cx('legal-disclaimer__section-list')}>
            {t('Legal_Disclaimer_Description_1', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('legal-disclaimer__section')}>
          <div className={cx('legal-disclaimer__section-title')}>{t('Legal_Disclaimer_Title_2')}</div>
          <div className={cx('legal-disclaimer__section-list')}>
            {t('Legal_Disclaimer_Description_2', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('legal-disclaimer__section')}>
          <div className={cx('legal-disclaimer__section-title')}>{t('Legal_Disclaimer_Title_3')}</div>
          <div className={cx('legal-disclaimer__section-list')}>
            {t('Legal_Disclaimer_Description_3', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('legal-disclaimer__section')}>
          <div className={cx('legal-disclaimer__section-title')}>{t('Legal_Disclaimer_Title_4')}</div>
          <div className={cx('legal-disclaimer__section-list')}>
            {t('Legal_Disclaimer_Description_4', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('legal-disclaimer__section')}>
          <div className={cx('legal-disclaimer__section-title')}>{t('Legal_Disclaimer_Title_5')}</div>
          <div className={cx('legal-disclaimer__section-list')}>
            {t('Legal_Disclaimer_Description_5', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('legal-disclaimer__section')}>
          <div className={cx('legal-disclaimer__section-title')}>{t('Legal_Disclaimer_Title_6')}</div>
          <div className={cx('legal-disclaimer__section-list')}>
            {t('Legal_Disclaimer_Description_6', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('legal-disclaimer__section')}>
          <div className={cx('legal-disclaimer__section-title')}>{t('Legal_Disclaimer_Title_7')}</div>
          <div className={cx('legal-disclaimer__section-list')}>
            {t('Legal_Disclaimer_Description_7', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LegalDisclaimer
